import { useEffect, useState } from 'react'
import theme from 'theme'
import { escapeRegExp } from 'lib/utils'
import { LabelOption } from '../ui/pages/library/components/LibrarySelectLabelField'

const UseSearchField = (options: LabelOption[], handleReset: any, combine = false) => {
  const [search, setSearch] = useState('')
  const [labelOptions, setLabelOptions] = useState(options)

  useEffect(() => {
    if (!search) {
      setLabelOptions(options)
      return
    }

    const filteredItems = options.filter((item) =>
      combine
        ? (item.label + ' ' + item.name).toLowerCase().includes(search.toLowerCase())
        : item.label.toLowerCase().includes(search.toLowerCase())
    )
    setLabelOptions(filteredItems)
  }, [options, search, combine])

  const highlightMatch = (text: string) => {
    if (!search) return text

    const regex = new RegExp(`(${escapeRegExp(search)})`, 'gi')
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span key={index} style={{ color: theme.colors.cta }}>
          {part}
        </span>
      ) : (
        part
      )
    )
  }

  const resetData = () => {
    setSearch('')
    handleReset()
  }

  return { search, labelOptions, setSearch, resetData, highlightMatch }
}

export default UseSearchField
